/// <amd-module name="ServiceHooks/Web/Admin/Context/DirtyChangesContext" />
import * as React from "react";
import { IDirtyChangesContext } from "./DirtyChangesContext.Types";

export const DirtyChangesContext = React.createContext<IDirtyChangesContext>({
    setHasDirtyChanges: () => {}
});
